export default __webpack_public_path__ + "static/media/hijacked.775bd200.jpg";